module.exports = __webpack_public_path__ + "static/media/pdf-upload.275f6d50.png";